<template>
	<div>
		<div class="bg" v-if="title=='单聊'">
			<div class="left">
				<div class="title">{{title}}</div>
				<div class="txt">
					<p>支持构建任何形式的消息类型</p>
					<p>文本消息</p>
					<p>富媒体类型消息(图片、语音、视频</p>
					<p>附件消息</p>
					<p>地理位置消息</p>
					<p>透传消息</p>
					<p>扩展消息等可以实现更多的业务对接</p>
				</div>
			</div>
			<div class="right">
				<slot></slot>
			</div>
		</div>
		<div class="bg" v-if="title=='群聊'">
			<div class="left">
				<div class="title">{{title}}</div>
				<div class="txt">
				<p>群组支持2000人聊天室支持5000人互动</p>
				<p>可集成直播平台打造直播聊天室场景</p>
				<p>提供丰富群聊管理功能</p>
				<p>提供群主、管理员、成员等角色身份</p>
				<p>管理员列表、成员列表、禁言列表、黑名单功能</p>
				<p>增值服务可开通群消息已读回执</p>
				<p>专有定制可支持10000人以上群聊互动</p>
				</div>
			</div>
			<div class="right">
				<slot></slot>
			</div>
		</div>
		<div class="bg" v-if="title=='消息推送'">
			<div class="left">
				<div class="title">{{title}}</div>
				<div class="txt">
					<p>海迅推送整体解决方案</p>
					<p>支持全消息类型收发,弹幕、礼物、点赞</p>
					<p>全终端覆盖,支持小程序、Web、移动端、桌面端</p>
					<p>支持横向扩展,推送类型自定义</p>
					<p>丰富的推送功能,全局推送，点对点，面对面</p>
					<p>消息合规服务,智能反垃圾、敏感词过滤、图片鉴黄等</p>
					<p>大幅减轻您的开发工作</p>
				</div>
			</div>
			<div class="right">
				<slot></slot>
			</div>
		</div>
		<div class="bg" v-if="title=='海迅通'">
			<div class="left">
				<div class="title">{{title}}</div>
				<div class="txt">
					<p>导入用户关系建立企业通讯录,创建全员群、部门群</p>
					<p>支持全类型消息收发,以及自定义消息实现</p>
					<p>1对1通话以及视频会议场景全覆盖</p>
					<p>服务器 可对接任何第三方业务</p>
					<p>提供完整的产品文档、上线服务支持</p>
					<p>2年研发积累,99.9%以上云服务集群保障</p>
				</div>
			</div>
			<div class="right">
				<slot></slot>
			</div>
		</div>
		<div class="bg" v-if="title=='私密社交'">
			<div class="left">
				<div class="title">{{title}}</div>
				<div class="txt">
				<p>支持全类型消息收发</p>
				<p>消息撤回、阅后即焚、实时音视频等丰富的功能</p>
				<p>反垃圾与敏感词保障内容合规</p>
				<p>高并发与稳定性确保弱网络消息必达</p>
				<p>多端多设备与消息漫游覆盖用户更多使用场景</p>
				<p>2年研发积累,99.9%以上云服务集群保障</p>
				</div>
			</div>
			<div class="right">
				<slot></slot>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		props: {
			title: String,
		}
	}
</script>

<style scoped="scoped">
	.bg {
		width: 1100px;
		height: 500px;
		background-color: #ffffff;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		padding-top: 50px;
		box-sizing: border-box;
	}

	.left {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 300px;
	}

	.txt {
		font-size: 13px;
	}

	.title {
		font-size: 25px;
	}
</style>
